import Head from 'next/head';
import { HeadTitleContent } from '../../../commons/Constants';
import { config } from '../../../config';
import { ingredientImages } from '../../images';
import Ingredients from '../../../components/body/Ingredients';

export default function IngredientPage() {
  const path_url = config.SiteURL.slice(0, -1);
  return (
    <>
      <Head>
        <meta
          property="og:title"
          content={HeadTitleContent['ingredients'].title}
          key="ogtitle"
        />
        <meta
          property="og:description"
          content={HeadTitleContent['ingredients'].description}
          key="ogdescription"
        />
        <meta
          property="og:url"
          content={path_url + HeadTitleContent['ingredients'].path}
          key="ogurl"
        />
        <meta
          property="og:image"
          content={path_url + ingredientImages['omega3']}
          key="ogimage"
        />
      </Head>
      <Ingredients />;
    </>
  );
}
export async function getStaticProps(context) {
  return {
    props: {
      extraMeta: {
        title: HeadTitleContent['ingredients'].title,
        description: HeadTitleContent['ingredients'].description,
      },
    },
  };
}
